import { useState, useEffect } from "react"
import { Link } from "react-router"
import { Button } from "@web/components/ui/button"
import { useLanguage } from "@web/lib/contexts/language-context"

const CONSENT_KEY = "cookie-consent"

export function CookieConsentBanner() {
  const { t } = useLanguage()
  const banner = t.cookieConsentBanner
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true)
    }
  }, [])

  function accept() {
    localStorage.setItem(CONSENT_KEY, "accepted")
    setVisible(false)
  }

  function reject() {
    localStorage.setItem(CONSENT_KEY, "rejected")
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 px-4 py-4 shadow-lg backdrop-blur-sm sm:px-6">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 lg:flex-row lg:items-center lg:gap-6">
        <p className="flex-1 text-sm text-muted-foreground">
          {banner.description}{" "}
          <Link
            to="/politica-de-privacidade"
            className="font-medium text-primary underline underline-offset-2 hover:text-primary/80"
          >
            {banner.privacyLink}
          </Link>
          {banner.descriptionSuffix && (
            <>{" "}{banner.descriptionSuffix}</>
          )}
        </p>
        <div className="flex w-full shrink-0 flex-col gap-2 sm:w-auto sm:flex-row">
          <Button onClick={accept} size="sm" className="w-full sm:w-auto">
            {banner.acceptAll}
          </Button>
          <Button onClick={reject} variant="secondary" size="sm" className="w-full sm:w-auto">
            <p className="text-white">
              {banner.rejectNonEssential}
            </p>
          </Button>
        </div>
      </div>
    </div>
  )
}
